import {fetchGet} from "../../requests/NetworkRequestAuth0";
import {uri} from "./AppRequest";

export const findVenueDancerDisplay = (
    venueId,
    successMethod,
    errorMethod,
    getAccessTokenSilently
) => {
    fetchGet(
        uri + "/user/venue/" + venueId + "/stage/display",
        successMethod,
        errorMethod,
        getAccessTokenSilently);
};

export const findStageDisplay = (
    venueId,
    successMethod,
    errorMethod,
    getAccessTokenSilently
) => {
    fetchGet(
        uri + "/venue/" + venueId + "/venue/stage/display",
        successMethod,
        errorMethod,
        getAccessTokenSilently);
};

export const findPreviousStages = (
    venueId,
    successMethod,
    errorMethod,
    getAccessTokenSilently
) => {
    fetchGet(
        uri + "/venue/" + venueId + "/venue/stage/previous",
        successMethod,
        errorMethod,
        getAccessTokenSilently);
};
